module.exports = __webpack_public_path__ + "img/ag2.35d89237.png";